var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-toast component",class:_vm.classList,on:{"click":_vm.remove}},[_vm._v(" "+_vm._s(_vm.item.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }